import { useEffect } from 'react'
import { devRevService, DEVREV_CONFIG } from '../config/devrev'
import { trackEvent } from '../utils/eventTracking.js'

let didInit = false

const ChatInitializer = () => {
  useEffect(() => {
    if (didInit) return
    didInit = true

    const init = async () => {
      let attempts = 0
      while (!window.plugSDK && attempts < 50) {
        await new Promise(r => setTimeout(r, 100))
        attempts++
      }
      if (!window.plugSDK) return

      const config = {
        app_id: DEVREV_CONFIG.APP_ID,
        enable_default_launcher: true,
        widget_alignment: 'right',
        spacing: { bottom: '20px', side: '20px' }
      }

      // Read user directly from localStorage (same source as AuthContext)
      try {
        const stored = localStorage.getItem('user')
        if (stored) {
          const user = JSON.parse(stored)
          const email = user.email || user.user_email || null
          if (email) {
            const displayName = user.display_name || user.displayName ||
              (user.user_metadata?.first_name && user.user_metadata?.last_name
                ? `${user.user_metadata.first_name} ${user.user_metadata.last_name}`.trim()
                : email.split('@')[0])

            const result = await devRevService.generateSessionToken(email, displayName)
            if (result.success && result.session_token) {
              config.session_token = result.session_token
              trackEvent('user_identified', {
                user_email: email,
                display_name: displayName,
                auth_method: 'session_token'
              })
            }
          }
        }
      } catch (_) {}

      window.plugSDK.init(config)
    }

    setTimeout(init, 1000)
  }, [])

  return null
}

export default ChatInitializer
